
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import Footer from '../../CoreComponents/Footer';
import Header from '../../CoreComponents/Header';
import MainHeader from '../../CoreComponents/MainHeader';
import NavBar from '../../CoreComponents/NavBar';
import { formValidation, ManagePromocode, showMessage } from '../../Functionalities/Functions';
import EditTopComponent from '../../CoreComponents/EditTopComponent'
import EditBottomComponent from '../../CoreComponents/EditBottomComponent'
import NoDataComponent from '../../CoreComponents/NoDataComponent'
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css' // Import css
import PromocodeComponent from './Component/PromocodeComponent';
import PromocodeUserComponent from './Component/PromocodeUserComponent';
import LoadingComponent from '../../CoreComponents/LoadingComponent';

function Body(props) {
  const [loading, setloading] = useState(true)
  const [edit, setEdit] = useState(false)
  const [data, setData] = useState({
    "id": "",
    "code": "",
    "disc_perc": '',
    "flat_disc": '',
    "is_active": '',
    "expiry_date": "",
    "recurrence": "",
    "alloed_users": [],
    "allowed_users": [],
    "from_date": "",
    "description": "",
    "uplimit": 0.0, //shabeeb change
    "is_for_new_user": false,
    "self_pickup_only": false,
  });

  const [flatDiscount, setFlatDiscount] = useState(false);
  const [discount, setDiscount] = useState(false);
  useEffect(() => {
    getData();
  }, []);
  
  useEffect(() => {
  }, [data])

  const [noData, setNoData] = useState(false)
  const getData = () => {
    let id = props.id;
    let result = ManagePromocode("", "", "get", `id=${id}`);
    result.then((res) => {
      if (res.data.results.length > 0) {
        setData({
          ...data,
          id: res.data.results[0].id,
          code: res.data.results[0].code,
          disc_perc: res.data.results[0].disc_perc,
          flat_disc: res.data.results[0].flat_disc,
          is_active: res.data.results[0].is_active,
          expiry_date: res.data.results[0].expiry_date && res.data.results[0].expiry_date.slice(0, 10),
          alloed_users: res.data.results[0].alloed_users,
          applicable_branches: res.data.results[0].applicable_branches,
          description: res.data.results[0].description,
          // allowed_users: res.data.results[0].alloed_users,
          recurrence: res.data.results[0].recurrence,
          from_date: res.data.results[0].from_date && res.data.results[0].from_date.slice(0, 10),
          uplimit: res.data.results[0].uplimit,
          min_amount: res.data.results[0].min_amount,
          is_for_new_user: res.data.results[0].is_for_new_user,
          self_pickup_only: res.data.results[0].self_pickup_only,
        });
        setloading(false)
      } else {
        setNoData(true)
        setloading(false)
      }

    });
  };
  const setUserListFunction = () => {
    let userList_data = []
    if (data.alloed_users.length > 0) {
      data.alloed_users.map(item => {
        userList_data.push(item.id)
      })
      return userList_data
    }
    return userList_data
  }
  // void 0
  return (
    <div>

      <div class="content-body">
        <div class="container-fluid">
          {!loading
            ? (!noData ?
              <>

                <EditTopComponent
                  BackButtonPath={"/promocode/"}
                  DeleteButton={(e) => {
                    e.preventDefault();
                    confirmAlert({
                      customUI: ({ onClose }) => {
                        return (
                          <div className='custom-ui' style={{ borderRadius: 8, border: 'solid', padding: 70, borderWidth: 0.5 }}>
                            <h1>Are you sure?</h1>
                            <p>You want to delete ?</p>
                            <button onClick={onClose} className="btn btn-primary" style={{ marginRight: 10, }}>Cancel</button>
                            <button

                              onClick={() => {

                                // return 0
                                let res = ManagePromocode(e, "", "delete", `id=${data.id}`)
                                res.then(result => {
                                  if (result.data.Status === true) {
                                    //alert('success')
                                    showMessage("Delete success", "success", "Success!", "top", "top-right")
                                    window.location.replace('/promocode')
                                  } else {
                                    showMessage("delete failed", "danger", "Failed!", "top", "top-right")
                                  }
                                }).catch(err => {
                                  showMessage("delete failed", "danger", "Error!", "top", "top-right")
                                })
                              }}
                              className="btn btn-primary"
                            >Delete</button>
                          </div>
                        );
                      }
                    });
                  }}
                  AddButtonName={"Add Promo Code"}
                  AddButtonPath={"/addpromo"}
                  CancelButton={(e) => {
                    e.preventDefault();
                    setEdit(false);
                  }}
                  EditButton={
                    (e) => {
                      e.preventDefault();
                      setEdit(true);
                    }
                  }
                  Edit={edit}
                />

                <div className="col-xl-12 col-lg-12">
                  <div className="card">
                    <form>
                      <div className="card-body">
                        <div className="basic-form">
                          <div className="form-row">
                            <div className="form-group col-md-6">
                              <label>Code<span className="required">*</span></label>
                              <input
                                type="text"
                                className="form-control"
                                disabled
                                value={data.code}
                                onChange={(e) => {
                                  setData({
                                    ...data,
                                    code: e.target.value,
                                  });
                                }}
                              />
                            </div>

                            <div className="form-group col-md-6">
                              <label>Discount percentage{data.disc_perc ? <span className="required">*</span> : <span className="required"></span>}&nbsp;<i className="fa fa-question-circle" style={{ cursor: "pointer" }} aria-hidden="true" title="Discount in percentage (%)" ></i></label>
                              <input
                                type="text"
                                className="form-control"
                                disabled={!edit}
                                value={data.disc_perc}
                                // disabled={discount}
                                onChange={(e) => {
                                  setData({
                                    ...data,
                                    disc_perc: e.target.value,
                                    flat_disc: "",
                                  });
                                }}
                                onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault() || evt.key === 'E' && evt.preventDefault()}
                                onWheelCapture={e => {
                                  e.target.blur()
                                }}
                              />
                            </div>
                            <div className="form-group col-md-6">
                              <label>Flat discount{data.flat_disc ? <span className="required">*</span> : <span className="required"></span>}&nbsp;<i className="fa fa-question-circle" style={{ cursor: "pointer" }} aria-hidden="true" title="Discount in Rupees" ></i></label>
                              <input
                                type="text"
                                className="form-control"
                                disabled={!edit}
                                value={data.flat_disc}
                                onChange={(e) => {
                                  setData({
                                    ...data,
                                    flat_disc: e.target.value,
                                    disc_perc: "",
                                  });
                                }}
                                onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault() || evt.key === 'E' && evt.preventDefault()}
                                onWheelCapture={e => {
                                  e.target.blur()
                                }}
                              />
                            </div>
                            <div className="form-group col-md-6">
                              <label>From Date</label>
                              <input type="date" className="form-control" disabled={!edit} value={data.from_date} onChange={(e) => {
                                setData({
                                  ...data,
                                  from_date: e.target.value,
                                });
                              }}
                              />
                            </div>
                            <div className="form-group col-md-6">
                              <label>Expiry Date<span className="required">*</span></label>
                              <input type="date" className="form-control" disabled={!edit} value={data.expiry_date}
                                onChange={(e) => {
                                  setData({
                                    ...data,
                                    expiry_date: e.target.value,
                                  });
                                }}
                              />
                            </div>
                            <div className="form-group col-md-6">
                              <label>Recurrence<span className="required">*</span>&nbsp;<i className="fa fa-question-circle" style={{ cursor: "pointer" }} aria-hidden="true" title="Number of times a user can use the promocode" ></i></label>
                              <input
                                type="number"
                                min={0}
                                className="form-control"
                                disabled={!edit}
                                value={data.recurrence}
                                onChange={(e) => {
                                  setData({
                                    ...data,
                                    recurrence: e.target.value,
                                  });
                                }}
                                onKeyDown={(evt) => (evt.key === 'e' || evt.key === '-') && evt.preventDefault() || evt.key === 'E' && evt.preventDefault()}
                                onWheelCapture={e => {
                                  e.target.blur()
                                }}
                              />
                            </div>
                            <div className="form-group col-md-6">
                              <label>Up limit<span className="required">*</span>&nbsp;<i className="fa fa-question-circle" style={{ cursor: "pointer" }} aria-hidden="true" title="Maximum discount value applicable" ></i></label>
                              <input
                                type="number"
                                min={0}
                                className="form-control"
                                value={data.uplimit}
                                onChange={(e) => {
                                  setData({ ...data, uplimit: e.target.value });
                                }}
                                onKeyDown={(evt) => (evt.key === 'e' || evt.key === '-') && evt.preventDefault() || evt.key === 'E' && evt.preventDefault()}
                                onWheelCapture={e => {
                                  e.target.blur()
                                }}
                              />
                            </div>
                            <div className="form-group col-md-6">
                              <label>Minimum Amount<span className="required">*</span>&nbsp;<i className="fa fa-question-circle" style={{ cursor: "pointer" }} aria-hidden="true" title="Minimum order amount to apply discount" ></i></label>
                              <input
                                type="number"
                                min={0}
                                className="form-control"
                                value={data.min_amount}
                                onChange={(e) => {
                                  setData({ ...data, min_amount: e.target.value });
                                }}
                                onKeyDown={(evt) => (evt.key === 'e' || evt.key === '-') && evt.preventDefault() || evt.key === 'E' && evt.preventDefault()}
                                onWheelCapture={e => {
                                  e.target.blur()
                                }}
                              />
                            </div>
                            <div className="form-group col-md-6">
                              <label>New Users Only</label>
                              <div className="form-check mt-2">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  disabled={!edit}
                                  checked={data.is_for_new_user}
                                  onChange={(e) =>
                                    setData({
                                      ...data,
                                      is_for_new_user: e.target.checked,
                                    })
                                  }
                                />
                                <label className="form-check-label ml-2">Restricted to new users only</label>
                              </div>
                            </div>
                            <div className="form-group col-md-6">
                              <label>Self-pickup orders only</label>
                              <div className="form-check mt-2">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  disabled={!edit}
                                  checked={data.self_pickup_only}
                                  onChange={(e) =>
                                    setData({
                                      ...data,
                                      self_pickup_only: e.target.checked,
                                    })
                                  }
                                />
                                <label className="form-check-label ml-2">Restricted to self-pickup orders only</label>
                              </div>
                            </div>
                            <div className="form-group col-md-12">
                            <label>Description{" "}
                              <span className="required"></span>
                            </label>
                            <textarea type="text"  className="form-control" value={data.description}
                              onChange={(e) => {
                                setData({ ...data, description: e.target.value })
                              }}
                              
                            />
                          </div >

                            <div className="form-group col-md-6 text-left">
                              <label>Active</label>
                              <div className="form-check ">
                                <input
                                  className="form-check-input text-center"
                                  type="checkbox"
                                  disabled={!edit}
                                  checked={data.is_active}
                                  onChange={(e) =>
                                    setData({
                                      ...data,
                                      is_active: e.target.checked,
                                    })
                                  }
                                />
                              </div>
                            </div>
                            <br />

                            {edit && <div className="form-group col-md-6">
                              <button type="button" class="btn btn-primary light form-control mb-2 mb-2" data-toggle="modal" data-target="#userSelectModal">Select Customer</button>
                              {data &&
                                <PromocodeComponent
                                  existingUser={data.alloed_users && data.alloed_users}
                                  customerFunction={(customerID) => {
                                    // void 0
                                    if (customerID) {
                                      setData({ ...data, allowed_users: customerID })
                                    }
                                    else {
                                      var list = setUserListFunction()
                                      setData({ ...data, allowed_users: list })
                                    }

                                  }
                                  } />}
                            </div>}

                            {data.alloed_users.length > 0 &&
                              <>
                                <div className="form-group col-md-12 text-left mt-4">
                                  <label>Allowed Users</label>&nbsp;<i className="fa fa-question-circle" style={{ cursor: "pointer" }} aria-hidden="true" title="Promocode is available only for listed customers" ></i>
                                </div>
                                <PromocodeUserComponent data={data} />

                              </>
                            }
                          </div>
                        </div>
                      </div>

                      {edit && (
                        <EditBottomComponent
                          cancelButton={(e) => {
                            e.preventDefault();
                            setEdit(false);
                          }}
                          saveButton={(e) => {
                            e.preventDefault();
                            // void 0
                            setEdit(false);
                            if (!data.allowed_users) {
                              var list = setUserListFunction()
                              setData({ ...data, allowed_users: list })
                              let x = { ...data, allowed_users: list }
                              let res = ManagePromocode(e, x, "update", "");
                              res.then((res) => {
                                if (res.data.Status) {
                                  showMessage("Promocode update success", "success", "Success!", "top", "top-right", 0)
                                  // window.location.reload()
                                  // setData({
                                  //   "id": "",
                                  //   "code": "",
                                  //   "disc_perc": 0.0,
                                  //   "flat_disc": 0.0,
                                  //   "is_active": '',
                                  //   "from_date": "",
                                  //   "expiry_date": "",
                                  //   "uplimit": 0.0, //shabeeb change
                                  //   "min_amount": "",
                                  //   "recurrence": "",
                                  //   "allowed_users": [],
                                  //   "applicable_branches": [],
                                  //   "description": "",
                                  // })
                                  // getData();

                                } else {
                                  showMessage(res.data.Error, "danger", "Error!", "top", "top-right", 0)
                                }
                              }).catch(err => {
                                // void 0
                              })
                            }
                            else {
                              let res = ManagePromocode(e, data, "update", "");
                              res.then((res) => {
                                if (res.data.Status) {
                                  showMessage("Promocode update success", "success", "Success!", "top", "top-right", 0)
                                } else {
                                  showMessage(res.data.Error, "danger", "Error!", "top", "top-right", 0)
                                }
                              }).catch(err => {
                                // void 0
                              })
                            }
                          }}
                        />
                      )}
                    </form>
                  </div>

                </div>
              </>
              : <NoDataComponent data="Promocode" />)
            : <LoadingComponent />
          }
        </div>
      </div>

    </div >
  );
}

function PromocodeEdit() {
  const headers = "Edit Promocode";
  let { id } = useParams();
  // void 0
  return (
    <div>
      <div id="main-wrapper">
        <MainHeader />
        <Header name={headers} />
        <NavBar />{" "}
        {/* <Body bo={boln} na={name} nu={num} ar={ary} ob={obj} ao={aryobj} /> */}
        <Body id={id} />
        <Footer />
      </div>
    </div>
  );
}
export default PromocodeEdit;